// extracted by mini-css-extract-plugin
export default {"select":"Dropdown_select__h2NUP"};